import styled from "styled-components";

const ItemStatusNavStyled = styled.div`
   width: 100%;
   height: 40px;
   border-radius: 8px;
   background: #F3F3F3;
   display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px;

  button {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background: inherit;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 400;
    color: #3D4543;
    
    &.active {
         background: #006150;
         font-weight: 700;
         color: #FFFFFF;
   }
  }

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    width: 42%;
  }
`

export { ItemStatusNavStyled };
